import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { shareReplay, startWith, Subject, switchMap, tap } from "rxjs";
import { Aircraft } from "../models";

@Injectable({ providedIn: "root" })
export class AircraftService {
  private readonly base = window.location.port === "4200" ? "/api" : "/api"; // dev et prod via /api

  private refresh$ = new Subject<void>();

  // flux public de la liste
  readonly aircrafts$ = this.refresh$.pipe(
    startWith(void 0), // premier chargement
    switchMap(() => this.http.get<Aircraft[]>(`${this.base}/aircraft`)),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(private http: HttpClient) {}

  getAircrafts() {
    return this.http.get<any[]>(`${this.base}/aircraft?filterByFavorites=1`);
  }

  update(id: string, changes: Partial<Aircraft>) {
    return this.http.put<Aircraft>(`${this.base}/aircraft/${id}`, changes).pipe(
      tap(() => this.refresh$.next()) // déclenche le rechargement
    );
  }

  create(data: Partial<Aircraft>) {
    return this.http
      .post<Aircraft>(`${this.base}/aircraft`, data)
      .pipe(tap(() => this.refresh$.next()));
  }

  remove(id: string) {
    return this.http
      .delete(`${this.base}/aircraft/${id}`)
      .pipe(tap(() => this.refresh$.next()));
  }
}
